import en from "./en.json";
import mn from "./mn.json";

export const Translate = { en, mn };
